import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ChartsConfigurationHelperService} from '@services/charts/helper/charts-configuration-helper.service';

@Component({
    selector: 'scitis-widget-content-type-selector',
    templateUrl: './widget-content-type-selector.component.html',
    styleUrls: ['./widget-content-type-selector.component.scss'],
    standalone: false
})
export class WidgetContentTypeSelectorComponent implements OnInit {
  @Input()
  widgetType: string = '';
  @Input()
  isDisabled: boolean = false;
  @Input()
  disableHint: string = '';
  @Output()
  widgetSelectorChange: EventEmitter<string> = new EventEmitter<string>();

  public widgetTypeTitle: string = '';
  public widgetTypeCssClass: string = '';

  constructor(private chartsConfigurationHelper: ChartsConfigurationHelperService) {
  }

  ngOnInit(): void {
    this.widgetTypeCssClass = this.chartsConfigurationHelper.determineWidgetTypeIconCssClass(this.widgetType);
    this.widgetTypeTitle = this.chartsConfigurationHelper.determineTitle(this.widgetType);
  }

  public onSelectWidgetType(): void {
    if (this.isDisabled) {
      return;
    }
    this.widgetSelectorChange.emit(this.widgetType);
  }
}
